import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HTTPTransactionService {
  private readonly loadingSubject$: BehaviorSubject<Array<string>> = new BehaviorSubject<Array<string>>([]);
  private readonly errorTransactions = new Set<string>();

  hasErrorTransactions(transactionsToCheck: string[]): boolean {
    return transactionsToCheck.some((transaction) =>
      Array.from(this.errorTransactions).some((errorTransaction) => errorTransaction.includes(transaction))
    );
  }

  addErrorTransaction(transactionContext: string): void {
    this.errorTransactions.add(transactionContext);
  }

  clearErrorTransactions(): void {
    this.errorTransactions.clear();
  }

  addHttpRequestState(transactionContext: string): void {
    this.loadingSubject$.next([...this.loadingSubject$.getValue(), transactionContext]);
  }

  removeHttpRequestState(transactionContext: string): void {
    this.loadingSubject$.next(this.loadingSubject$.getValue().filter((context) => context !== transactionContext));
  }

  getHttpRequestState(): Observable<Array<string>> {
    return this.loadingSubject$.asObservable();
  }
}
